export interface UtmBuilderItem {
    id: string
    name: string
    color: string
    created_at: Date
}

export const UtmBuilderItemGenerator = {
    empty(): UtmBuilderItem {
        return { id: '', name: '', color: '', created_at: new Date() }
    },
}
